const TOOL = {
  validator_number_must_8: (rule, value, callback) => {
    if (/^[0-9]{8}$/.test(value)) {
      callback()
    } else {
      return callback(new Error('必填，且必须为8位数字'))
    }
  },
  validator_number_must_6: (rule, value, callback) => {
    if (/^[0-9]{6}$/.test(value)) {
      callback()
    } else {
      return callback(new Error('必填，且必须为6位数字'))
    }
  },
  validator_number_must_4: (rule, value, callback) => {
    if (/^[0-9]{4}$/.test(value)) {
      callback()
    } else {
      return callback(new Error('必填，且必须为4位数字'))
    }
  },
  validator_number_must_2: (rule, value, callback) => {
    if (/^[0-9]{2}$/.test(value)) {
      callback()
    } else {
      return callback(new Error('必填，且必须为2位数字'))
    }
  },
  validator_number_must: (rule, value, callback) => {
    if (/^[0-9]+$/.test(value)) {
      callback()
    } else {
      return callback(new Error('必填，且必须为数字'))
    }
  },
  validator_number_8: (rule, value, callback) => {
    if (/^[0-9]{8}$/.test(value) || !value) {
      callback()
    } else {
      return callback(new Error('必须为8位数字'))
    }
  },
  validator_number_6: (rule, value, callback) => {
    if (/^[0-9]{6}$/.test(value) || !value) {
      callback()
    } else {
      return callback(new Error('必须为6位数字'))
    }
  },
  validator_number_4: (rule, value, callback) => {
    if (/^[0-9]{4}$/.test(value) || !value) {
      callback()
    } else {
      return callback(new Error('必须为4位数字'))
    }
  },
  validator_number_2: (rule, value, callback) => {
    if (/^[0-9]{2}$/.test(value) || !value) {
      callback()
    } else {
      return callback(new Error('必须为2位数字'))
    }
  },
  validator_number: (rule, value, callback) => {
    if (/^[0-9]+$/.test(value) || !value) {
      callback()
    } else {
      return callback(new Error('必须为数字'))
    }
  },
  toHidePhone: val => {
    const str = String(val);
    const len = str.length;
    if (len <= 3) {
      // 长度小于等于3，全显示
      return str;
    } else if (len > 3 && len < 7) {
      // 大于3小于7，显示前3位后面用*替代
      const firstThree = str.substring(0, 3);
      const stars = '*'.repeat(len - 3);
      return firstThree + stars;
    } else {
      // 大于等于7，显示前3位和后4位，中间用*替代
      const firstThree = str.substring(0, 3);
      const lastFour = str.substring(len - 4);
      const starCount = len - 7; // 中间*的数量
      const stars = starCount > 0 ? '*'.repeat(starCount) : '';
      return firstThree + stars + lastFour;
    }
  },
  toYMD: date => {
    if (!date) return ''
    if (typeof date === 'number') {
      date = new Date(date)
      const y = date.getFullYear()
      const m = date.getMonth() + 1
      const d = date.getDate()
      return `${y}-${m < 10 ? '0' + m : m}-${d < 10 ? '0' + d : d}`
    } else {
      return date
    }
  },

  toDate: (date) => {
    if (!date) return new Date();
    
    if (date instanceof Date) {
      return new Date(date.getTime());
    } else if (typeof date === 'number') {
      // 处理10位时间戳
      if (date.toString().length === 10) {
        return new Date(date * 1000);
      }
      return new Date(date);
    } else if (typeof date === 'string') {
      // 处理10位时间戳字符串
      if (/^\d{10}$/.test(date)) {
        return new Date(parseInt(date) * 1000);
      }
      return new Date(date.replace(/-/g, '/'));
    }
    return null;
  },
  getYear: (date) => {
    const d = TOOL.toDate(date) || new Date();
    return d.getFullYear();
  },
  getMonth: (date, fillZero) => {
    const d = TOOL.toDate(date) || new Date();
    const month = d.getMonth() + 1;
    return fillZero && month < 10 ? `0${month}` : `${month}`;
  },
  getDate: (date, fillZero) => {
    const d = TOOL.toDate(date) || new Date();
    const day = d.getDate();
    return fillZero && day < 10 ? `0${day}` : `${day}`;
  },
  getDay: (date) => {
    const d = TOOL.toDate(date) || new Date();
    const day = d.getDay();
    return day === 0 ? 7 : day;
  },
  getTimestamp: (date) => {
    const d = TOOL.toDate(date) || new Date();
    return d.getTime();
  },
  getDaysInMonth: (year, month) => {
    if (!year || !month) return null;
    return new Date(year, month, 0).getDate();
  },
  getStartAndEndTimestamp(date) {
    const d = TOOL.toDate(date) || new Date();
    const startOfDay = d;
    startOfDay.setHours(0, 0, 0, 0);
    const startTimestamp = startOfDay.getTime();
    
    const endOfDay = d;
    endOfDay.setHours(23, 59, 59, 999);
    const endTimestamp = endOfDay.getTime();
    
    return { startTimestamp, endTimestamp };
  },
  timeFormat: (date, format = 'YYYY-MM-DD') => {
    const d = TOOL.toDate(date);
    if (!d) return '';
    
    const pad = (num) => num.toString().padStart(2, '0');
    
    const tokens = {
      'YYYY': d.getFullYear().toString(),
      'YY': d.getFullYear().toString().slice(-2),
      'MM': pad(d.getMonth() + 1),
      'M': (d.getMonth() + 1).toString(),
      'DD': pad(d.getDate()),
      'D': d.getDate().toString(),
      'HH': pad(d.getHours()),
      'H': d.getHours().toString(),
      'hh': pad(d.getHours() % 12 || 12),
      'h': (d.getHours() % 12 || 12).toString(),
      'mm': pad(d.getMinutes()),
      'm': d.getMinutes().toString(),
      'ss': pad(d.getSeconds()),
      's': d.getSeconds().toString(),
      'a': d.getHours() < 12 ? 'am' : 'pm',
      'A': d.getHours() < 12 ? 'AM' : 'PM',
      'd': ['日', '一', '二', '三', '四', '五', '六'][d.getDay()],
    };
    
    return format.replace(/YYYY|YY|MM|M|DD|D|HH|H|hh|h|mm|m|ss|s|a|A|d/g, match => tokens[match]);
  },
  formatMilliseconds: (ms) => {
    // 将秒转换为秒（整数）
    const totalSeconds = Math.floor(ms);
    
    // 计算小时、分钟和剩余秒数
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    
    // 构建时间字符串
    const parts = [];
    if (hours > 0) parts.push(`${hours}小时`);
    if (minutes > 0) parts.push(`${minutes}分钟`);
    
    // 确保至少显示"0秒"当所有单位都是0时
    if (seconds > 0 || parts.length === 0) {
        parts.push(`${seconds}秒`);
    }
    
    return parts.join('');
  },
}

export default TOOL